<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <el-input
        placeholder="请输入昵称或手机号码进行搜索"
        v-model="body.keyword"
        clearable
        class="input-with-select dk_input"/>
      <div>
        <span style="line-height: 40px;margin-right:10px">提交时间</span>
        <el-date-picker
          v-model="times"
          clearable
          value-format="yyyy-MM-dd"
          @change="onTimeChange()"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"/>
      </div>
      <el-button
        type="primary"
        @click="search()">
        搜索
      </el-button>
      <el-button @click="event().clearKeyword()">重置</el-button>
      <div>
        <el-button
          type="primary"
          @click="event().toExchangeRulesEdit()">
          兑换规则编辑
        </el-button>
      </div>
    </div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick">
      <el-tab-pane
        label="全部"
        name="all">
        <!-- 表格 -->
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="nickname"
            label="用户昵称"/>
          <el-table-column
            prop="mobile"
            label="手机号码"/>
          <el-table-column
            prop="user_name"
            label="收款人姓名"/>
          <el-table-column
            prop="bank_name"
            label="开户行信息"/>
          <el-table-column
            prop="bank_card"
            label="银行卡号"/>
          <el-table-column
            prop="consume"
            label="消耗积分"/>
          <el-table-column
            prop="money"
            label="兑换金额"/>
          <el-table-column
            prop="create_time"
            label="提交时间"/>
          <el-table-column
            prop="status"
            label="状态"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toDetailClick(scope.row.uuid)">
                详情
              </el-button>
              <el-button
                v-if="scope.row.status === '待处理'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toConfirmClick(scope.row.uuid)">
                通过
              </el-button>
              <el-button
                v-if="scope.row.status === '待处理'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toRefuseClick(scope.row.uuid)">
                拒绝
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="待处理"
        name="pending">
        <!-- 表格 -->
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="nike_name"
            label="用户昵称"/>
          <el-table-column
            prop="mobile"
            label="手机号码"/>
          <el-table-column
            prop="user_name"
            label="收款人姓名"/>
          <el-table-column
            prop="bank_name"
            label="开户行信息"/>
          <el-table-column
            prop="bank_card"
            label="银行卡号"/>
          <el-table-column
            prop="consume"
            label="消耗积分"/>
          <el-table-column
            prop="money"
            label="兑换金额"/>
          <el-table-column
            prop="create_time"
            label="提交时间"/>
          <el-table-column
            prop="status"
            label="状态"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toDetailClick(scope.row.uuid)">
                详情
              </el-button>
              <el-button
                v-if="scope.row.status === '待处理'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toConfirmClick(scope.row.uuid)">
                通过
              </el-button>
              <el-button
                v-if="scope.row.status === '待处理'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toRefuseClick(scope.row.uuid)">
                拒绝
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="已通过"
        name="passed">
        <!-- 表格 -->
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="nike_name"
            label="用户昵称"/>
          <el-table-column
            prop="mobile"
            label="手机号码"/>
          <el-table-column
            prop="user_name"
            label="收款人姓名"/>
          <el-table-column
            prop="bank_name"
            label="开户行信息"/>
          <el-table-column
            prop="bank_card"
            label="银行卡号"/>
          <el-table-column
            prop="consume"
            label="消耗积分"/>
          <el-table-column
            prop="money"
            label="兑换金额"/>
          <el-table-column
            prop="create_time"
            label="提交时间"/>
          <el-table-column
            prop="status"
            label="状态"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toDetailClick(scope.row.uuid)">
                详情
              </el-button>
              <el-button
                v-if="scope.row.status === '待处理'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toConfirmClick(scope.row.uuid)">
                通过
              </el-button>
              <el-button
                v-if="scope.row.status === '待处理'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toRefuseClick(scope.row.uuid)">
                拒绝
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="已拒绝"
        name="rejected">
        <!-- 表格 -->
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="nike_name"
            label="用户昵称"/>
          <el-table-column
            prop="mobile"
            label="手机号码"/>
          <el-table-column
            prop="user_name"
            label="收款人姓名"/>
          <el-table-column
            prop="bank_name"
            label="开户行信息"/>
          <el-table-column
            prop="bank_card"
            label="银行卡号"/>
          <el-table-column
            prop="consume"
            label="消耗积分"/>
          <el-table-column
            prop="money"
            label="兑换金额"/>
          <el-table-column
            prop="create_time"
            label="提交时间"/>
          <el-table-column
            prop="status"
            label="状态"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toDetailClick(scope.row.uuid)">
                详情
              </el-button>
              <el-button
                v-if="scope.row.status === '待处理'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toConfirmClick(scope.row.uuid)">
                通过
              </el-button>
              <el-button
                v-if="scope.row.status === '待处理'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toRefuseClick(scope.row.uuid)">
                拒绝
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>

    <!-- 通过兑换 -->
    <el-dialog
      width="480px"
      title="提示，是否确认通过 ?"
      :visible.sync="toConfirmBodyDialog">
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="toConfirmBodyDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureToConfirmClick()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 拒绝兑换 -->
    <el-dialog
      width="350px"
      title="提示，确认是否拒绝 ?"
      :visible.sync="toRefuseBodyDialog">
      <el-form
        :model="toRefuseBody"
        ref="ruleForm3"
        class="demo-ruleForm">
        <el-input
          placeholder="请输入拒绝理由"
          type="textarea"
          class="dk-input"
          v-model="toRefuseBody.content"/>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="toRefuseBodyDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureToRefuseClick('ruleForm3')">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { getExchangeData, setExchangeStatus } from '../../api/exchange'
import { imgDomain } from '../../configs/env'
import timeChange from '../../mixins/time-change'
import { setId } from '../../jslib/set-id'

export default {
  mixins: [timeChange],
  data() {
    return {
      imgDomain,
      body: {
        keyword: '',
        status: '',
        page_index: 1,
        page_size: 10,
      },
      times: [],
      total: 0,
      tableData: [
        {},
      ],
      activeName: 'all',
      toConfirmBodyDialog: false,
      toRefuseBodyDialog: false,
      toConfirmBody: {},
      toRefuseBody: {},
    };
  },

  components: {
  },
  created() {
    this.network().getExchangeData()
  },
  methods: {
    handleCurrentChange() {
      this.network().getExchangeData()
    },
    search() {
      this.network().getExchangeData()
    },
    handleClick(tab, event) {
      if (tab.name === 'all') {
        this.body.status = ''
      } else if (tab.name === 'pending') {
        this.body.status = 0
      } else if (tab.name === 'passed') {
        this.body.status = 1
      } else if (tab.name === 'rejected') {
        this.body.status = 2
      }
      this.network().getExchangeData()
    },
    event() {
      return {
        clearKeyword: () => {
          this.body.keyword = ''
          this.times = []
          this.body.begin_time = ''
          this.body.end_time = ''
        },
        toConfirmClick: (uuid) => {
            this.toConfirmBody.uuid = uuid
            this.toConfirmBodyDialog = true
        },
        toRefuseClick: (uuid) => {
          this.toRefuseBody.uuid = uuid
          this.toRefuseBodyDialog = true
        },
        onSureToConfirmClick: () => {
          this.toConfirmBody.status = 1;
          this.network().setExchangeStatus(this.toConfirmBody)
        },
        onSureToRefuseClick: () => {
          this.toRefuseBody.status = 2;
          this.network().setExchangeStatus(this.toRefuseBody)
        },
        toDetailClick: (uuid) => {
          this.$router.push({ path: 'detail', query: { uuid } })
        },
        toExchangeRulesEdit: () => {
          this.$router.push({ path: 'exchange-rules' })
        },
      }
    },
    network() {
      return {
        getExchangeData: async () => {
          const { status, data } = await getExchangeData(this.body)
          if (status !== 200) return
          this.tableData = setId(data.data, this.body.page_index, this.body.page_size)
          this.tableData = data.data
          this.total = data.total
        },
        setExchangeStatus: async (data) => {
          const { status } = await setExchangeStatus(data)
          if (status !== 200) return
          this.network().getExchangeData()
          if (data.status === 1) {
            this.toConfirmBodyDialog = false
            this.$notify({
              title: '通过成功',
              message: '通过成功',
              type: 'success',
            });
          } else if (data.status === 2) {
            this.toRefuseBodyDialog = false
            this.$notify({
              title: '拒绝成功',
              message: '拒绝成功',
              type: 'success',
            });
          }
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/exchange/list.vue